import {processTimingEvent} from 'performance/BenchlingProfiler';

import {ProfilerEvent, ProfilerEventDomain} from './ProfilerConstants';

const DOMAIN = ProfilerEventDomain.GRAPHQL;
const PROFILER_GRAPHQL_EVENTS_VERSION = 1;

export enum ProfilerGraphQLFeatures {
  GRAPHQL_QUERY = 'graphQLQuery',
}

enum ProfilerGraphQLActions {
  QUERY_STARTED = 'queryStarted',
  QUERY_FINISHED = 'queryEnded',
}

export const QUERY_STARTED_EVENT: ProfilerEvent = {
  domain: DOMAIN,
  feature: ProfilerGraphQLFeatures.GRAPHQL_QUERY,
  action: ProfilerGraphQLActions.QUERY_STARTED,
};

export const QUERY_FINISHED_EVENT: ProfilerEvent = {
  domain: DOMAIN,
  feature: ProfilerGraphQLFeatures.GRAPHQL_QUERY,
  action: ProfilerGraphQLActions.QUERY_FINISHED,
};

export function processGraphQLEvents(): void {
  processTimingEvent(
    QUERY_STARTED_EVENT,
    QUERY_FINISHED_EVENT,
    'GraphQL Query',
    'perf.graphql.query',
    PROFILER_GRAPHQL_EVENTS_VERSION
  );
}
